module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default", [_vm._v("\n    ** AutomaticScroll Component **\n")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-307b07ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/AutomaticScroll.vue
// module id = 2499
// module chunks = 1